export default [
        //基础信息管理
        {
            path: '/basic/dict',
            component: () => import( '@/views/basic/dict.vue'),
            meta: {
                title: '数据字典管理',
                isTabsPage: true,
                keepAlive:true
            }
        },
        {
            path: '/basic/user',
            component: () => import( '@/views/basic/user.vue'),
            meta: {
                title: '用户管理',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            path: '/basic/user_grant',
            component: () => import( '@/views/basic/user_grant.vue'),
        },
        {
            path: '/basic/role',
            component: () => import( '@/views/basic/role.vue'),
            meta: {
                title: '角色管理',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            name: '/basic/role_grant',
            path: '/basic/role_grant',
            component: () => import( '@/views/basic/role_grant.vue'),
        },
        {
            path: '/basic/resource',
            component: () => import( '@/views/basic/resource.vue'),
            meta: {
                title: '资源管理',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            path: '/basic/file',
            component: () => import( '@/views/basic/BscFileInfo.vue'),
            meta: {
                title: '系统附件',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            path: '/basic/RedisManager',
            component: () => import( '@/views/basic/RedisManager.vue'),
            meta: {
                title: 'Redis缓存清理',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            path: '/basic/TaskManager',
            component: () => import( '@/views/basic/TaskManager.vue'),
            meta: {
                title: '手动跑Task',
                isTabsPage: true,
                keepAlive: true
            }
        },
        {
            path: '/basic/OrderEasy',
            component: () => import( '@/views/basic/OrderEasy.vue'),
            meta: {
                title: '订单维护',
                isTabsPage: true,
                keepAlive: true
            }
        },
    ]
